// src/components/tools/measureSlideoutContent.js
//
// Pure derivation: measure hook state → string the slide-out pill should
// display, or null when the pill should not appear at all. Lives outside
// MeasureToolPanel.jsx so that file can stay component-only (keeps the
// react-refresh fast-refresh boundary clean).

import { formatDistance, formatArea } from "../../hooks/useMeasure";

const EM_SPACE = " ";

/**
 *   not active                  → null   (caller skips render)
 *   active, 0 verts, no result  → null
 *   in-progress (≥1 vert)       → "<distance>"   (open polyline; cursor = next)
 *   line result                 → "<distance>"
 *   area result                 → "<perimeter>   <area>"  (closed ring)
 */
export function deriveSlideoutContent({ active, vertexCount, liveStats, result }) {
  if (!active) return null;
  if (result?.kind === "line") return formatDistance(result.distance);
  if (result?.kind === "area") {
    return `${formatDistance(result.perimeter)}${EM_SPACE}${formatArea(result.area)}`;
  }
  if (vertexCount === 0) return null;
  if (liveStats?.kind === "line") return formatDistance(liveStats.distance);
  return null;
}
